import { Action } from '@ngrx/store';
import { FollowShipment } from '@app/models/follow-shipment';

export enum FollowShipmentActionTypes {
  Load = '[FollowShipment] Load follow shipments',
  LoadSuccess = '[FollowShipment] Load follow shipments success',
  LoadFail = '[FollowShipment] Load follow shipments fail',
  AddOne = '[FollowShipment] Add one',
  AddMany = '[FollowShipment] Add many',
  AddAll = '[FollowShipment] Add all',
  Create = '[FollowShipment] Create follow shipment',
  CreateSuccess = '[FollowShipment] Create follow shipment success',
  CreateFail = '[FollowShipment] Create follow shipment fail',
  Delete = '[FollowShipment] Delete follow shipment',
  DeleteSuccess = '[FollowShipment] Delete follow shipment success',
  DeleteFail = '[FollowShipment] Delete follow shipment fail',
  RemoveOne = '[FollowShipment] Removes one shipment',
  Update = '[API] Update FollowShipment',
  UpdateSuccess = '[FollowShipment] Update FollowShipment success',
  UpdateFail = '[FollowShipment] Update FollowShipment fail',
  UpdateOne = '[FollowShipment] Update FollowShipment one',
  UpdateMany = '[API] Update many FollowShipment',
  UpdateManySuccess = '[API] Update many FollowShipment succes',
  UpdateManyFail = '[API] Update many FollowShipment fail',
}

export class Load implements Action {
  readonly type = FollowShipmentActionTypes.Load;
  constructor(public FollowId: number, public infoview?: any) {}
}

export class LoadSuccess implements Action {
  readonly type = FollowShipmentActionTypes.LoadSuccess;
  constructor(public shipments: FollowShipment[]) {}
}

export class LoadFail implements Action {
  readonly type = FollowShipmentActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class Create implements Action {
  readonly type = FollowShipmentActionTypes.Create;
  constructor(public FollowId: number, public data: any) {}
}

export class CreateSuccess implements Action {
  readonly type = FollowShipmentActionTypes.CreateSuccess;
  constructor(public shipments: FollowShipment[]) {}
}

export class CreateFail implements Action {
  readonly type = FollowShipmentActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class AddOne implements Action {
  readonly type = FollowShipmentActionTypes.AddOne;
  constructor(public shipment: FollowShipment) {}
}

export class AddMany implements Action {
  readonly type = FollowShipmentActionTypes.AddMany;
  constructor(public shipments: FollowShipment[]) {}
}

export class AddAll implements Action {
  readonly type = FollowShipmentActionTypes.AddAll;
  constructor(public shipments: FollowShipment[]) {}
}

export class Delete implements Action {
  readonly type = FollowShipmentActionTypes.Delete;
  constructor(public shipment) {}
}

export class DeleteSuccess implements Action {
  readonly type = FollowShipmentActionTypes.DeleteSuccess;
  constructor(public shipment) {}
}

export class DeleteFail implements Action {
  readonly type = FollowShipmentActionTypes.CreateSuccess;
  constructor(public error: any) {}
}

export class RemoveOne implements Action {
  readonly type = FollowShipmentActionTypes.RemoveOne;
  constructor(public shipment: number) {}
}

export class Update implements Action {
  readonly type = FollowShipmentActionTypes.Update;
  constructor(public id: number, public shipment) {}
}

export class UpdateFail implements Action {
  readonly type = FollowShipmentActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class UpdateSuccess implements Action {
  readonly type = FollowShipmentActionTypes.UpdateSuccess;
  constructor(public id: number, public data: any) {}
}

export class UpdateOne implements Action {
  readonly type = FollowShipmentActionTypes.UpdateOne;
  constructor(public shipment: FollowShipment) {}
}


export class UpdateMany implements Action {
  readonly type = FollowShipmentActionTypes.UpdateMany;
  constructor(public id: number, public shipments: any) {}
}

export class UpdateManySuccess implements Action {
  readonly type = FollowShipmentActionTypes.UpdateManySuccess;
  constructor(public id: number, public data: any) {}
}

export class UpdateManyFail implements Action {
  readonly type = FollowShipmentActionTypes.UpdateManyFail;
  constructor(public error: any) {}
}

export type FollowShipmentActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | Create
  | CreateSuccess
  | CreateFail
  | AddAll
  | AddOne
  | AddMany
  | Delete
  | DeleteSuccess
  | DeleteFail
  | RemoveOne
  | Update
  | UpdateSuccess
  | UpdateFail
  | UpdateOne
  | UpdateMany
  | UpdateManySuccess
  | UpdateManyFail;
